import React, { useEffect, useState } from 'react';
import { Input, Modal, message } from 'antd';
import type { SessionHistoryItem } from '../types';

interface HistoryRenameModalProps {
  visible: boolean;
  loading?: boolean;
  item: SessionHistoryItem | null;
  onCancel: () => void;
  onConfirm: (title: string) => Promise<void> | void;
}

const HistoryRenameModal: React.FC<HistoryRenameModalProps> = ({ visible, loading = false, item, onCancel, onConfirm }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!visible) {
      setValue('');
      return;
    }
    setValue(item?.title || '');
  }, [item, visible]);

  const handleConfirm = async () => {
    const nextTitle = value.trim();
    if (!nextTitle) {
      message.warning('标题不能为空');
      return;
    }
    await onConfirm(nextTitle);
  };

  return (
    <Modal title="重命名会话" open={visible} okText="确认" cancelText="取消" confirmLoading={loading} onOk={handleConfirm} onCancel={onCancel} destroyOnClose>
      <Input className="session-history-menu-footer-modal-input" value={value} maxLength={50} placeholder="请输入新名称（1-50字符）" onChange={(event) => setValue(event.target.value)} />
    </Modal>
  );
};

export default HistoryRenameModal;
